// ⚠️⚠️⚠️⚠️ AUTO GENERATED FILE ⚠️⚠️⚠️⚠️ DO NOT EDIT ⚠️⚠️⚠️⚠️
/** Internal type. DO NOT USE DIRECTLY. */
type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
import type * as Types from '../../schema';

import gql from '@workspace/graphql-codegen-fetch';
import { ErrorsFragmentDoc } from './UpdateUserSettingsMutation';
export type UserManagementGetAuthClearanceInput = {
  captcha?: string | null | undefined;
  captchaVersion?: string | null | undefined;
  clientMutationId?: string | null | undefined;
  site?: string | null | undefined;
  username?: string | null | undefined;
};

export type GetAuthClearanceMutationVariables = Exact<{
  input: Types.UserManagementGetAuthClearanceInput;
}>;


export type GetAuthClearanceMutation = { userManagementGetAuthClearance: { authClearanceId: string | undefined, errors: Array<{ message: string | undefined, params: Array<{ name: string | undefined, value: string | undefined } | undefined> | undefined } | undefined> | undefined } | undefined };


export const GetAuthClearanceMutationDocument = gql`
    mutation GetAuthClearanceMutation($input: UserManagementGetAuthClearanceInput!) {
  userManagementGetAuthClearance(input: $input) {
    authClearanceId
    errors {
      ...ErrorsFragment
    }
  }
}
    ${ErrorsFragmentDoc}`;